import Newsletter_45_container from "./container/Newsletter_45_container";
export default Newsletter_45_container;
